<script>
// https://vuejs.org/v2/guide/render-function.html

export default {
  name: "module-heading",
  props: {
    level: {
      type: Number,
      required: false,
      default: 2
    }
  },
  render(createElement) {
    return createElement(
      "h" + this.level, // tag name
      {
        // options
        class: {
          "module-header": true
        }
      },
      this.$slots.default // array of children
    );
  }
};
</script>
